import BookIcon from "./BookIcon.mjs";

export default class MyLibraryIcon extends BookIcon {}
